// extracted by mini-css-extract-plugin
export default {"pinHead":"pinHead-module--pin-head--ava-m","icon":"pinHead-module--icon--9Ojmy","activeIcon":"pinHead-module--active-icon--SZ9eF","isPin":"pinHead-module--is-pin--WRlhn"};